<div id="sunburst" #sunburst class="h-100 w-100">
    <p *ngIf="!sunburstData.length" class="mt">No Data</p>
</div>